import * as React from 'react';
import { connect } from 'react-redux';
import { changeGround3dData } from '../../../actions/actions';
import { DisplayFeatureType, Ground3dData } from '../../contract-features-3/domain';
import FeaturesState from "../../contract-features-3/domain/FeaturesState";

interface OptionsProps {
    selectedFeatureType: DisplayFeatureType,
    ground3dData: Ground3dData,
    changeGround3dData: Function
}

interface OptionsState {
}

class Options extends React.Component<OptionsProps, OptionsState> {

    componentDidMount() {
        if (this.props.ground3dData == undefined) {
            this.props.changeGround3dData(new Ground3dData(true, false, false, 100, 0));
        }
    }

    render() {
        if (this.props.ground3dData == undefined) {
            return null;
        }

        return (
            <section className='render-3d-options' >
                <section className='category-header'>
                    <label>
                        <input type='checkbox'
                               checked={this.props.ground3dData.show}
                               onChange={() => this.props.changeGround3dData(
                                   new Ground3dData(
                                       !this.props.ground3dData.show,
                                       this.props.ground3dData.follow,
                                       this.props.ground3dData.filled,
                                       this.props.ground3dData.squareSize,
                                       this.props.ground3dData.height))}/>
                        <span>Vis bakkereferanse</span>
                    </label>
                </section>
                {!this.props.ground3dData.show ? null :
                    <section className='category-body'>
                        <label
                            title={'Bakkereferansen følger etter punktet du ser på med kameraet. ' +
                            'Nyttig for kontrakter med areal større enn bakkereferansen.'}>
                            <input type='checkbox'
                                   checked={this.props.ground3dData.follow}
                                   onChange={() => this.props.changeGround3dData(
                                       new Ground3dData(
                                           this.props.ground3dData.show,
                                           !this.props.ground3dData.follow,
                                           this.props.ground3dData.filled,
                                           this.props.ground3dData.squareSize,
                                           this.props.ground3dData.height))}/>
                            <span>Følg kamera</span>
                        </label>
                        <label
                            title={'Fyller bakkereferansen med et heldekkende gjennomsiktig lag. ' +
                            'Dette gjør det lettere å sammenligne nivå.'}>
                            <input type='checkbox'
                                   checked={this.props.ground3dData.filled}
                                   onChange={() => this.props.changeGround3dData(
                                       new Ground3dData(
                                           this.props.ground3dData.show,
                                           this.props.ground3dData.follow,
                                           !this.props.ground3dData.filled,
                                           this.props.ground3dData.squareSize,
                                           this.props.ground3dData.height))}/>
                            <span>Heldekkende</span>
                        </label>
                        <label
                            title={'Hver rute i bakkereferansen tilsvarer ' +
                            `${this.props.ground3dData.squareSize}x${this.props.ground3dData.squareSize} meter. ` +
                            'OBS! Liten rutestørresle kan føre til dårlig ytelse.'}>
                            <span>Rutestørrelse <i>({this.props.ground3dData.squareSize} m)</i></span>
                            <input type='range'
                                   min='1'
                                   max='1000'
                                   value={this.props.ground3dData.squareSize}
                                   onChange={(event) => this.props.changeGround3dData(
                                       new Ground3dData(
                                           this.props.ground3dData.show,
                                           this.props.ground3dData.follow,
                                           this.props.ground3dData.filled,
                                           +event.target.value,
                                           this.props.ground3dData.height))}/>
                        </label>
                        <label
                            title={'Justert bakkereferansehøyde for bakkereferansen utifra GPS null-nivå. ' +
                            'Bakkereferansens startnivå (0 meter) baseres på nullnivået til koordinatsystemet WGS84.'}>
                            <span>Høyde <i>(+{this.props.ground3dData.height} m)</i></span>
                            <input type='range'
                                   min='0'
                                   max='1000'
                                   value={this.props.ground3dData.height}
                                   onChange={(event) => this.props.changeGround3dData(
                                       new Ground3dData(
                                           this.props.ground3dData.show,
                                           this.props.ground3dData.follow,
                                           this.props.ground3dData.filled,
                                           this.props.ground3dData.squareSize,
                                           +event.target.value))}/>
                        </label>
                    </section>}
                <div className='separator'/>
            </section>
        );
    }

}

const mapStateToProps = (state: FeaturesState) => {
    return {
        selectedFeatureType: state.selectedFeatureType,
        ground3dData: state.ground3dData
    };
};
const mapOptionsDispatchToProps = ({
    changeGround3dData: changeGround3dData
});
export default connect(
    mapStateToProps,
    mapOptionsDispatchToProps
)(Options);
